<div class="relative w-full bg-white p-12 shadow-lg mt-[80px]">
    <div class="max-w-7xl mx-auto flex items-center justify-start">
        <h1 class="text-3xl font-bold text-gray-900 aarni-font md:ml-2">
            Program Fee 2025-26
        </h1>
    </div>
</div>

<div class="flex items-start justify-center p-4 bg-gray-50 aarni-font">
    <div class="flex flex-col lg:flex-row gap-4 p-4 w-full max-w-7xl">
        <aside class="w-full lg:w-1/4 space-y-4 lg:h-[950px] lg:overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Applying to ARNI</h2>
                    <div>
                        <a
                            href="/admissions/overview"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive('/admissions/overview'),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive('/admissions/overview')
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-y border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Overview</span>
                        </a>

                        <a
                            *ngFor="let link of [
            { href: '/admissions/campus-virtual-tour', label: 'Campus Virtual Tour' },
            { href: '/admissions/criteria', label: 'Admission Criteria' },
            { href: '/admissions/flow', label: 'Admission Flow' },
            { href: '/admissions/program-fee', label: 'Program Fees' },
            { href: '/admissions/hostel-fee', label: 'Accommodation & Hostel' },
            { href: '/admissions/transportation-fee', label: 'Transportation Services' },
            { href: '/admissions/scholarship', label: 'Scholarship Opportunities' },
            { href: '/admissions/innovative-idea-scholarship', label: 'Innovative Idea Grants' },
            { href: '/admissions/fee-structure-for-previous-year-students', label: 'Fee Structures for Previous Year Students' },
            { href: '/admissions/education-loan-assistance', label: 'Education Loan Support' },
            { href: '/admissions/how-to-apply', label: 'How to Apply' },
            { href: '/quick-links/contact-us', label: 'Counseling Services' },
            { href: '/admissions/payment-procedure', label: 'Payment Procedure' },
            { href: '/admissions/refund-policy', label: 'Refund Policy' },
            { href: '/admissions/avenues-for-success', label: 'Avenues for Success@ARNI' },
            { href: '/admissions/lateral-entry-or-migration', label: 'Lateral Entry/Migration' },
            { href: '/admissions/faqs', label: 'FAQs' }
          ]"
                            [href]="link.href"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive(link.href),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive(link.href)
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-b border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>{{ link.label }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </aside>
        <section class="flex-1 shadow-lg p-6 border-2 border-gray-200 bg-white h-fit">
            <h1 class="text-2xl font-bold mb-4">Program Fee Structure</h1>
            <!--            <div class="flex justify-center border-b">-->
            <!--                <button-->
            <!--                    (click)="toggleTab('national')"-->
            <!--                    class="px-6 py-2 font-semibold"-->
            <!--                    [class.text-green-600]="selectedTab === 'national'"-->
            <!--                    [class.border-b-2]="selectedTab === 'national'"-->
            <!--                    [class.border-green-500]="selectedTab === 'national'"-->
            <!--                >-->
            <!--                    Programme Fee National-->
            <!--                </button>-->
            <!--                <button-->
            <!--                    (click)="toggleTab('international')"-->
            <!--                    class="px-6 py-2 font-semibold"-->
            <!--                    [class.text-green-600]="selectedTab === 'international'"-->
            <!--                    [class.border-b-2]="selectedTab === 'international'"-->
            <!--                    [class.border-green-500]="selectedTab === 'international'"-->
            <!--                >-->
            <!--                    Programme Fee International-->
            <!--                </button>-->
            <!--            </div>-->

            <p class="text-gray-600 my-6">
                Click on the following school to get a better insight of various programmes and their respective fee
                structure.
            </p>
            <form [formGroup]="filterCoursesForm">
                <div class="flex gap-4 mt-4">

                    <div class="w-1/2">
                        <select (change)="getBranches()" formControlName="course_id"
                                class="border px-3 py-2 rounded-md shadow-sm w-full min-w-0 outline-none">
                            <option value="" selected>Select Course</option>
                            <option *ngFor="let course of courses" [value]="course?.id">
                                {{ course?.name }}
                            </option>
                        </select>
                    </div>

                    <div class="w-1/2">
                        <select formControlName="branch_id"
                                class="border px-3 py-2 rounded-md shadow-sm w-full min-w-0 outline-none"
                                (change)="filterBranches()">
                            <option value="" selected>Select Branch</option>
                            <option *ngFor="let branch of branches"
                                    [value]="branch?.branch?.id || 'general'">{{ branch?.branch?.name || 'General' }}
                            </option>
                        </select>
                    </div>
                </div>
            </form>

            <div class="mt-6 space-y-6">
                <div *ngFor="let course of filteredCourses" class="border rounded-lg shadow-md p-4">
                    <div class="flex justify-between items-center mb-2">
                        <h2 class="text-lg font-bold">{{ course?.branch?.name || course?.course?.name }}</h2>
                        <div class="flex gap-4">
                            <button class="px-4 py-2 bg-green-600 text-white rounded-md">
                                <a href="/form/apply-form">Apply</a>
                            </button>
                        </div>
                    </div>

                    <div class="flex border-b">
                        <button
                            *ngIf="course?.result_type === 'SEMESTER'"
                            (click)="toggleFeeType('semester', course)"
                            class="px-4 py-2"
                            [class.bg-gray-800]="course.fee_type === 'semester'"
                            [class.text-white]="course.fee_type === 'semester'"
                            [class.rounded-t-md]="course.fee_type === 'semester'"
                        >
                            Semester Fee
                        </button>
                        <button
                            (click)="toggleFeeType('yearly', course)"
                            [ngClass]="{'bg-black text-white rounded-t-md': course?.result_type === 'YEAR'}"
                            class="px-4 py-2 text-gray-600"
                            [class.bg-gray-800]="course.fee_type === 'yearly'"
                            [class.text-white]="course.fee_type === 'yearly'"
                            [class.rounded-t-md]="course.fee_type === 'yearly'"
                        >
                            Yearly Fee
                        </button>
                    </div>

                    <div *ngIf="course.fee_type === 'semester' && course?.result_type === 'SEMESTER'"
                         class="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
                        <div *ngFor="let fee of course?.semester_fee">
                            <p class="font-semibold text-center">Semester {{ fee?.semester }}</p>
                            <p class="text-gray-600 font-medium text-center">₹{{ fee?.fee }}</p>
                        </div>
                    </div>

                    <div *ngIf="course.fee_type === 'yearly' || course?.result_type === 'YEAR'"
                         class="mt-4 text-lg grid grid-cols-2 md:grid-cols-4 gap-4 text-gray-800">
                        <div *ngFor="let fee of course?.fees" class="">
                            <p class="font-semibold text-center">Year {{ fee?.year }}</p>
                            <p class="text-gray-600 text-center font-medium">₹{{ fee?.total_fee }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
